import FilterText from './FilterText';

export default FilterText;
